import { Datagrid, EditButton, StateCollectionInput } from "ra-friendsofbabba";
import {
  DateField,
  List as RaList,
  TextField,
  useGetIdentity,
  usePermissions,
} from "react-admin";
import React, { Fragment, useMemo } from "react";

import Actions from "../component/list/Actions";
import Empty from "../component/list/Empty";
import { ExportMenuButton } from "../component/button";
import Filters from "./Filters";
import HelpBlock from "../component/HelpBlock";
import UserField from "../component/field/UserField";
import { useFieldLabel } from "ra-friendsofbabba";

const List = (props) => {
  const fieldLabel = useFieldLabel(props);
  const { identity } = useGetIdentity();
  const { loaded, permissions } = usePermissions();
  const { isAdmin, isTro, isMir, isManager } = useMemo(
    () => ({
      isAdmin: loaded && permissions(["admin"]),
      isTro: loaded && permissions(["tro"]),
      isMir: loaded && permissions(["mir"]),
      isManager: loaded && permissions(["manager"]),
    }),
    [loaded, permissions]
  );

  const additionalProps = isAdmin ? {} : { bulkActionButtons: false };
  return (
    <Fragment>
      <HelpBlock
        {...props}
        visibleFor={["researcher"]}
        context="list"
        visible={
          identity?.permissions &&
          identity?.permissions.indexOf("executive-projects") === -1
        }
      />
      <HelpBlock {...props} visibleFor={["tro"]} context="export" />
      <RaList
        {...props}
        {...additionalProps}
        filters={<Filters />}
        actions={
          <Actions canExport={false}>
            {(isAdmin || isTro || isManager | isMir) && (
              <ExportMenuButton
                choices={
                  isAdmin || isMir ? ["zip", "mir", "xlsx"] : ["zip", "xlsx"]
                }
              />
            )}
          </Actions>
        }
        exporter={false}
        empty={<Empty canCreate={isAdmin} />}
        sort={{ field: "UserOutputs.created", order: "ASC" }}
      >
        <Datagrid rowClick="edit">
          <TextField source="id" label="#ID" sortBy="UserOutputs.id" />
          <UserField
            label={fieldLabel("user_id")}
            source="user.name"
            sortBy="UserProfiles.name"
          />
          <StateCollectionInput
            source="state"
            readonly={!isAdmin}
            admin={isAdmin}
            sortable={false}
          />
          <DateField source="modified" sortBy="UserOutputs.modified" showTime />
          <EditButton />
        </Datagrid>
      </RaList>
    </Fragment>
  );
};
export default List;
